import React from "react";
import {
  ThemedSider as DefaultSider,
} from "@refinedev/mui";
import { useGetIdentity } from "@refinedev/core";
import { Avatar, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import PersonOutlineOutlined from "@mui/icons-material/PersonOutlineOutlined";
import { useNavigate, useLocation } from "react-router-dom";
import type { IIdentity } from "../interfaces";
import { usePermissions } from "../hooks";

export const CustomSider: React.FC<any> = (props) => {
  const { data: user } = useGetIdentity<IIdentity>();
  const { hasFullAccess, isLoading: permsLoading } = usePermissions();
  const navigate = useNavigate();
  const location = useLocation();
  const isProfileActive = location.pathname.startsWith("/profile");

  return (
    <DefaultSider
      {...props}
      collapsedWidth={64}
      render={({ items, logout, collapsed }) => {
        return (
          <>
            {/* Custom Profile Menu Item — available to any signed-in user. */}
            {user && (
              <ListItemButton
                onClick={() => navigate("/profile")}
                selected={isProfileActive}
                sx={{ pl: 2, py: 1, justifyContent: "center", color: "text.primary" }}
              >
                <ListItemIcon
                  sx={{
                    justifyContent: "center",
                    minWidth: "24px",
                    transition: "margin-right 0.3s",
                    marginRight: collapsed ? "0px" : "12px",
                    color: "currentColor",
                  }}
                >
                  <Avatar
                    src={user.photo?.url || undefined}
                    alt={user.name || user.id || "User"}
                    sx={{ width: 24, height: 24, fontSize: "14px", bgcolor: user.photo?.url ? undefined : "transparent" }}
                  >
                    {user.photo?.url ? (
                      (user.name || user.id || "U").charAt(0).toUpperCase()
                    ) : (
                      <PersonOutlineOutlined fontSize="small" />
                    )}
                  </Avatar>
                </ListItemIcon>
                <ListItemText
                  primary={user.name || user.id || "User"}
                  primaryTypographyProps={{ noWrap: true, fontSize: "14px" }}
                />
              </ListItemButton>
            )}

            {/* Other menu items.
                - "profiles" and "billing-transactions" are admin-only (FOUNDER
                  or is_admin). Hide them for non-admin users.
                - The "properties" resource stays visible to all users.
                - While the user identity is still loading, show all items
                  rather than hiding admin-only ones (the loading state
                  returns hasFullAccess: false). */}
            {items.filter((item: any) => {
              if (permsLoading) return true;
              if (!hasFullAccess && (item?.props?.resource === "profiles" || item?.props?.resource === "billing-transactions")) {
                return false;
              }
              return true;
            })}
            {logout}
          </>
        );
      }}
    />
  );
}; 